import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'ppl-box-container',
    templateUrl: './box-container.component.html',
    styleUrls: ['./box-container.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class BoxContainerComponent {
  @Input() small = false;
}
